import * as RadixDialog from '@radix-ui/react-dialog';
import { X } from 'lucide-react';
import type { ReactNode } from 'react';
import { cn } from '../utils/cn';

interface DialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  title: ReactNode;
  description?: ReactNode;
  children: ReactNode;
  footer?: ReactNode;
  className?: string;
}

export function Dialog({
  open,
  onOpenChange,
  title,
  description,
  children,
  footer,
  className,
}: DialogProps) {
  return (
    <RadixDialog.Root open={open} onOpenChange={onOpenChange}>
      <RadixDialog.Portal>
        <RadixDialog.Overlay className="fixed inset-0 z-40 bg-ink/45 backdrop-blur-[2px]" />
        <RadixDialog.Content
          className={cn(
            'fixed inset-0 z-50 m-auto flex h-fit max-h-[90vh] w-[min(560px,92vw)] flex-col ' +
              'bg-surface text-ink rounded-lg overflow-hidden elev-pop',
            className,
          )}
        >
          <header className="flex items-start justify-between gap-6 border-b hairline px-6 pt-5 pb-4">
            <div>
              <RadixDialog.Title className="font-display text-xl tracking-snug">
                {title}
              </RadixDialog.Title>
              {description ? (
                <RadixDialog.Description className="mt-1 text-[14px] text-graphite">
                  {description}
                </RadixDialog.Description>
              ) : null}
            </div>
            <RadixDialog.Close className="text-graphite hover:text-ink p-1 -m-1 transition-colors">
              <X className="size-5" />
            </RadixDialog.Close>
          </header>
          <div className="px-6 py-5 overflow-y-auto">{children}</div>
          {footer ? (
            <footer className="border-t hairline px-6 py-4 bg-surface-tint">{footer}</footer>
          ) : null}
        </RadixDialog.Content>
      </RadixDialog.Portal>
    </RadixDialog.Root>
  );
}
